"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgUserBan = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M15 6.812c0-1.3-1.218-2.814-3-2.814s-2.996 1.462-2.996 3c0 1.553 1.23 2.994 2.998 2.994l.24.006-1.7 1.784a5 5 0 116.102-6.641L15 6.811v.001zM2 19.783C2 15.045 5.331 13.998 7.776 14c0-.002-5.776 5.783-5.776 5.783zm18.002.215c0-2.667-1.333-4-4-4h-1.745a596.85 596.85 0 012.029-1.997c3.81-.002 5.714 1.997 5.714 5.997 0 1.333-.667 2-2 2H8.283l2.001-2h9.718zM18.207 6.365c.463-.48.935-.48 1.414 0 .48.48.48.95 0 1.415l-13.9 13.9c-.46.481-.931.481-1.414 0-.482-.483-.482-.954 0-1.415l13.9-13.9z' }))); };
exports.default = SvgUserBan;
//# sourceMappingURL=UserBan.js.map